import HeaderMobile from './HeaderMobile';

export default HeaderMobile;